export default {
    "name": "CheckoutDiscountCodeApply",
    "kind": "HoudiniMutation",
    "hash": "9717432a11c962e765f6d4b1fcf6ac40f2aec02552506400eec6044f7ba809e4",

    "raw": `mutation CheckoutDiscountCodeApply($checkoutId: ID!, $discountCode: String!, $country: CountryCode!, $language: LanguageCode!) @inContext(country: $country, language: $language) {
  checkoutDiscountCodeApplyV2(
    checkoutId: $checkoutId
    discountCode: $discountCode
  ) {
    checkout {
      id
    }
    checkoutUserErrors {
      code
      field
      message
    }
  }
}
`,

    "rootType": "Mutation",

    "selection": {
        "fields": {
            "checkoutDiscountCodeApplyV2": {
                "type": "CheckoutDiscountCodeApplyV2Payload",
                "keyRaw": "checkoutDiscountCodeApplyV2(checkoutId: $checkoutId, discountCode: $discountCode)",
                "nullable": true,

                "selection": {
                    "fields": {
                        "checkout": {
                            "type": "Checkout",
                            "keyRaw": "checkout",
                            "nullable": true,

                            "selection": {
                                "fields": {
                                    "id": {
                                        "type": "ID",
                                        "keyRaw": "id",
                                        "visible": true
                                    }
                                }
                            },

                            "visible": true
                        },

                        "checkoutUserErrors": {
                            "type": "CheckoutUserError",
                            "keyRaw": "checkoutUserErrors",

                            "selection": {
                                "fields": {
                                    "code": {
                                        "type": "CheckoutErrorCode",
                                        "keyRaw": "code",
                                        "nullable": true,
                                        "visible": true
                                    },

                                    "field": {
                                        "type": "String",
                                        "keyRaw": "field",
                                        "nullable": true,
                                        "visible": true
                                    },

                                    "message": {
                                        "type": "String",
                                        "keyRaw": "message",
                                        "visible": true
                                    }
                                }
                            },

                            "visible": true
                        }
                    }
                },

                "visible": true
            }
        }
    },

    "pluginData": {
        "houdini-svelte": {}
    },

    "input": {
        "fields": {
            "checkoutId": "ID",
            "discountCode": "String",
            "country": "CountryCode",
            "language": "LanguageCode"
        },

        "types": {}
    }
};

"HoudiniHash=f752b728646a5a8103e8782f13705cf44b43efb88c1a28e69da32a737d515ebf";